import { render, staticRenderFns } from "./SecurityDepositsList.vue?vue&type=template&id=7f84b164&"
import script from "./SecurityDepositsList.vue?vue&type=script&lang=js&"
export * from "./SecurityDepositsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports